/// <amd-module name="Build/Admin/Common/Stores/ResourceLimitStore" />
import { Store } from "VSS/Reflux/Store";

import { ResourceLimit } from "DistributedTask/Client/Contracts/TaskAgent";

import { StoreStatus } from "Build/Admin/Common/Constants";

export interface IResourceLimitStoreState {
    resourceLimits: ResourceLimit[];
    resourceLimitsStatus: StoreStatus;
}

export class ResourceLimitStore extends Store {
    public state: IResourceLimitStoreState;

    constructor() {
        super("ResourceLimitStoreChanged");

        this.state = {
            resourceLimits: [],
            resourceLimitsStatus: StoreStatus.None
        };
    }

    public resourceLimitsUpdated = (resourceLimits: ResourceLimit[]): void => {
        this.state = {
            ...this.state,
            resourceLimits,
            resourceLimitsStatus: StoreStatus.Loaded
        };
        this.emitChanged();
    }

    public resourceLimitsStatusUpdated = (resourceLimitsStatus: StoreStatus): void => {
        this.state = {
            ...this.state,
            resourceLimitsStatus
        };
        this.emitChanged();
    }
}
